import React, { useEffect, useState } from 'react';
import useCountUp from '../../../../hooks/useCountUp';

const parseNumber = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    const str = String(value).replace(/[^0-9.-]/g, '');
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
};

const KpiCard = ({ title, value, unit, change, changeType }) => {
    const numericValue = parseNumber(value);
    const [startCount, setStartCount] = useState(false);
    const { count } = useCountUp(numericValue || 0, 800, startCount);

    useEffect(() => {
        const timer = setTimeout(() => setStartCount(true), 600);
        return () => clearTimeout(timer);
    }, []);

    const displayValue = numericValue !== null ? count : value;

    return (
        <div className="clinic-dashboard-kpi-card">
            <div className="clinic-dashboard-kpi-label">{title}</div>
            <div className="clinic-dashboard-kpi-value">{displayValue}</div>
            {unit && <div className="clinic-dashboard-kpi-unit">{unit}</div>}
            {change && (
                <div className={`clinic-dashboard-kpi-change ${changeType}`}>
                    {changeType === 'up' ? '↑' : '↓'} {change}
                    <span className="clinic-dashboard-kpi-change-vstext">vs previous period</span>
                </div>
            )}
        </div>
    );
};

export default KpiCard;
